import styled from 'styled-components';

export const StyledBoundButtons = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
`;
